// AWS
const api = "https://jap.57concrete.com/api";
// const api = "http://localhost:4000/api";
module.exports = {
	api,
};
